import defaultSettings from '../settings'

const title = defaultSettings.title || 'SID Technology'

export default function getPageTitle (pageTitle, noShowTitle) {
  if (pageTitle) {
    if (noShowTitle) {
      return `${pageTitle}`
    }
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js